import React from 'react';
import PropTypes from 'prop-types';

import uuid from '../../scripts/uuidv4';

import './styles.less';

class Tweet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uniqueId: props.contentId || uuid(),
            tweetId: props.tweetId || /https:\/\/twitter\.com\/.*\/status\/(.*).*/.exec(props.tweetUrl)[1]
        };
    }

    componentDidMount() {

      const TwitterWidgetsLoader = require('twitter-widgets');
      TwitterWidgetsLoader.load(() => {
        window.twttr.ready().then(({ widgets }) => {
            widgets.createTweet(this.state.tweetId, document.getElementById(this.state.uniqueId));
        });
      });

}

    render() {
        return <div className="p-tweet" data-content-id={this.props.contentId} id={this.state.uniqueId} />;
    }
}

Tweet.propTypes = {
    contentId: PropTypes.string,
    tweetId: PropTypes.string,
    tweetUrl: PropTypes.string
};

Tweet.defaultProps = {
    contentId: undefined,
    tweetId: undefined,
    tweetUrl: undefined
};

export default Tweet;
